import { rulesAndAlertsFormModel } from './rulesAndAlertsFormModel';

const {
  formField: { name, description, status, assignedUsers },
} = rulesAndAlertsFormModel;

export default {
  [name.name]: '',
  [description.name]: '',
  [status.name]: true, // true para "Activa"
  [assignedUsers.name]: [],
};
